<template>
    <div class="card">
        <div class="earth-container">
            <img class="earth-image" src="@/assets/earth-bg.jpg" alt="earth" />
            <div v-for="item in markers" :key="item.label" class="marker" :style="{ top: item.top, left: item.left }">
                <div class="line"></div>
                <div class="label-box">
                    <div class="label">{{ item.label }}</div>
                    <div class="value">{{ item.value }}个</div>
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>
const markers = [
    { label: '美国', value: 243, top: '20%', left: '80%' },
    { label: '法国', value: 143, top: '25%', left: '60%' },
    { label: '德国', value: 132, top: '25%', left: '65%' },
    { label: '新加坡', value: 26, top: '55%', left: '50%' },
    { label: '韩国', value: 37, top: '40%', left: '65%' },
    { label: '日本', value: 243, top: '45%', left: '75%' },
]
</script>

<style scoped>
.earth-container {
    position: relative;
    width: 100%;
    height: 500px;
}

.earth-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(1.2);
    border-radius: 8px;
}

.marker {
    position: absolute;
    transform: translate(-50%, -50%);
    text-align: left;
    display: flex;
    align-items: center;
}

.line {
    width: 2px;
    height: 30px;
    background: #00ffff;
    margin-right: 5px;
}

.label-box {
    background: rgba(0, 102, 204, 0.7);
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    color: #ffffff;
    white-space: nowrap;
}

.label-box .label {
    font-weight: bold;
}

.label-box .value {
    font-size: 11px;
    color: #00ffcc;
}
</style>